module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('defs', [_c('circle', {
    attrs: {
      "id": "a",
      "cx": "40",
      "cy": "40",
      "r": "40"
    }
  })]), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('mask', {
    attrs: {
      "id": "b",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#C4C4C4",
      "fill-rule": "nonzero",
      "xlink:href": "#a"
    }
  }), _c('g', {
    attrs: {
      "mask": "url(#b)",
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#879196",
      "d": "M30.32 56.49h19.76l.05-7.64H30.32z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#E6B693",
      "d": "M31.8 38.28h16.82v22.99H31.8z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#A2AFB5",
      "d": "M53.07 85.61V54.67L40.21 59.4 27 54.67v30.94z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#627680",
      "d": "M42.35 65.93H38.1l-2.33-6.5h8.92z"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "fill": "#BFBFBF",
      "d": "M29.83 68.51L40.2 59.4 28.4 64.96zM50.6 68.51L40.21 59.4l11.84 5.57z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#627680",
      "d": "M48.97 85.61l-6.9-21.34h-3.7l-6.9 21.34z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#A2AFB5",
      "d": "M40.21 59.4L30.2 65.15l-2.9-13.26 3.03-3.05zM40.21 59.4l10.03 5.76 2.9-13.26-3.01-3.05z"
    }
  }), _c('path', {
    attrs: {
      "d": "M64.73 85.61c.07-1.06 6.18-26.67 6.18-26.67L52.3 51.07 39.75 85.6h24.98z",
      "fill": "#4C595E"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M44.26 85.61c8.61-11.68 14.65-20.19 14.65-20.19l-6.37-3.96a23 23 0 006.93-1.54c-1.06-4.78-7.16-8.85-7.16-8.85L39.75 85.6h4.51z",
      "fill": "#BFBFBF"
    }
  }), _c('path', {
    attrs: {
      "d": "M43.38 85.61A1146.38 1146.38 0 0057.3 64l-4.77-2.53c1.5-1.06 3.1-1.96 4.77-2.69a18.3 18.3 0 00-5-8.36l-12.62 35.2h3.69z",
      "fill": "#4C595E"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.52 85.61h24.85L27.83 51.07 9.55 58.94s4.34 15.99 5.73 24.9c.13.58.21 1.17.24 1.77z",
      "fill": "#4C595E"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M27.63 61.46l-5.82 3.91s5.62 8.28 14.33 20.3h4.05L27.33 51.56s-5.09 4.02-6.15 8.81a15.3 15.3 0 006.45 1.09z",
      "fill": "#BFBFBF"
    }
  }), _c('path', {
    attrs: {
      "d": "M23.26 63.65s5.54 9.56 13.56 21.96h3.59L27.87 50.48a17.72 17.72 0 00-5.02 8.29c1.69.73 3.29 1.63 4.78 2.69l-4.37 2.2zM15.99 85.61a90.57 90.57 0 00-6.44-26.67S4.17 68.06 3.5 85.6h12.49zM64.48 85.61a90.57 90.57 0 016.46-26.67S76.29 68 76.9 85.6H64.48z",
      "fill": "#4C595E"
    }
  }), _c('path', {
    attrs: {
      "d": "M27.36 36.38c.14 1.03.41 1.72-.46 1.95-.87.23-2.15.67-2.58-1.6-.37-2.47-.95-4.9-1.73-7.26-.16-1.12.5-2.2 1.59-2.54a1.86 1.86 0 012.09 1.6l1.09 7.85zM52.4 36.38c-.14 1.03-.41 1.72.46 1.95.87.23 2.15.67 2.58-1.6.38-2.47.96-4.9 1.74-7.26a2.39 2.39 0 00-1.59-2.54 1.87 1.87 0 00-2.1 1.6l-1.08 7.85z",
      "fill": "#E6B693"
    }
  }), _c('path', {
    attrs: {
      "d": "M39.88 10.07c-7.58 0-13.73 5.4-13.73 12.1v14.47c0 6.68 6.15 12.09 13.73 12.09V10.07z",
      "fill": "#E6B693"
    }
  }), _c('path', {
    attrs: {
      "d": "M39.88 10.07v13c-.1 3.76 0 9.03-2.3 12.9-1.62 2.74.74 3.43 2.3 3.43 0 .97-.44 1.89-1.2 2.5.56.6-.2 1.55-.23 1.96.15.3 1.25.83 1.49 1.4a1.87 1.87 0 00-2.26 1.6c0 .98.83 1.82 2.26 1.82 7.58 0 13.73-5.4 13.73-12.08V22.16c-.06-6.64-6.2-12.1-13.79-12.1z",
      "fill": "#E6B693"
    }
  }), _c('path', {
    attrs: {
      "d": "M56.04 17.8c-.96-3.08-3.7-8.36-16.09-8.36-12.4 0-15.13 5.32-16.07 8.36-1.58 5.11.78 10.3 2.21 14.14 1.37-2.8 2.8-5.13 1.37-10.61-1.86-7.35 6.74-9.68 12.44-9.68 5.71 0 14.33 2.4 12.45 9.68-1.39 5.48 0 7.82 1.42 10.61 1.48-3.83 3.83-9.03 2.27-14.14z",
      "fill": "#FAFAFA"
    }
  }), _c('path', {
    attrs: {
      "d": "M35.3 27.65l-4.53.67a1.2 1.2 0 01-1.43-.9 1.2 1.2 0 011.02-1.26l4.54-.66a1.2 1.2 0 011.42.9 1.11 1.11 0 01-1.01 1.25zM53.59 32.24c-.43.32-.78.73-1.05 1.2a8.87 8.87 0 01-3.21 7.6c-1.62-3.58-7.23-1.58-9.44-1.58-2.2 0-7.83-1.96-9.44 1.58a8.9 8.9 0 01-3.26-7.6 3.9 3.9 0 00-1.1-1.2s-1.4 8.92 3.15 14.5c2.08 2.54 7.7 4.38 10.6 4.38 2.92 0 8.52-1.84 10.6-4.39 4.55-5.62 3.15-14.5 3.15-14.5zM44.45 27.65l4.55.67a1.2 1.2 0 001.42-.86 1.12 1.12 0 00-1.01-1.26l-4.55-.66a1.2 1.2 0 00-1.42.9 1.11 1.11 0 001.01 1.21z",
      "fill": "#FAFAFA"
    }
  }), _c('path', {
    attrs: {
      "d": "M45.53 41.11c-.36.53-1.4 2.96-5.7 3.36-4.3-.4-5.33-2.83-5.7-3.36-.32 3.13.68 5.3 5.7 5.3 5.03 0 6.02-2.17 5.7-5.3z",
      "fill": "#E6B693"
    }
  }), _c('path', {
    attrs: {
      "d": "M39.83 41.35c-1.75.04-3.5-.18-5.2-.63a.33.33 0 00-.43.39 6.07 6.07 0 0011.41 0 .31.31 0 00-.4-.37c-1.76.44-3.57.65-5.38.6z",
      "fill": "#B0573E"
    }
  }), _c('path', {
    attrs: {
      "d": "M35.07 40.85c.14.75.75 2.3 4.77 2.3 4.03 0 4.78-1.72 4.91-2.39-1.6.38-3.25.57-4.9.57-1.61.03-3.21-.13-4.78-.48z",
      "fill": "#FFF"
    }
  }), _c('path', {
    attrs: {
      "d": "M39.83 41.35c-1.6.03-3.2-.14-4.77-.5V41l.07.2.1.2c1.45.47 2.99.68 4.52.6 1.6.08 3.2-.16 4.7-.7v-.1c.05-.1.1-.2.12-.3v-.11c-1.55.36-3.14.55-4.74.55z",
      "fill": "#C4C4C4"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M40.21 66.41c-.59 0-1.17-.13-1.7-.4a2.1 2.1 0 001.7 1.36c.79-.1 1.45-.63 1.72-1.36-.53.27-1.12.4-1.72.4z",
      "fill": "#BFBFBF"
    }
  })]), _c('path', {
    attrs: {
      "d": "M34.39 31.73a.57.57 0 00.6.53.57.57 0 00.62-.53v-1.45a.57.57 0 00-.61-.54.57.57 0 00-.61.54v1.45z",
      "fill": "#3E2D1E",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M34.63 30.66c0 .2.08.34.19.34.1 0 .2-.15.2-.34 0-.19-.1-.33-.2-.33-.11 0-.2.15-.2.33z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M45.27 31.73a.57.57 0 00.6.53.57.57 0 00.61-.53v-1.45a.57.57 0 00-.6-.54.57.57 0 00-.61.54v1.45z",
      "fill": "#3E2D1E",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M45.48 30.66c0 .2.08.34.2.34.1 0 .2-.15.2-.34 0-.19-.1-.33-.2-.33-.12 0-.2.15-.2.33z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M47.27 26.71c-3.15 0-5 .56-5.74 1.27a3.7 3.7 0 00-2.25-.61c-.49.05-.95.24-1.33.55-.78-.68-2.6-1.2-5.68-1.2-3.97 0-6.12 1.04-6.12 2.03 0 1.98.38 6.6 3.9 6.6 3.32 0 5.69-.71 7.04-2.1a5.44 5.44 0 001.31-4.2v-.13c.24-.3.6-.5.98-.53.64-.03 1.27.18 1.77.59v.07a5.44 5.44 0 001.31 4.2c1.35 1.39 3.71 2.1 7.04 2.1 3.34 0 3.9-4.62 3.9-6.6 0-1-2.15-2.04-6.13-2.04zm-10.91 5.83c-1.2 1.2-3.27 1.78-6.32 1.78-2.55 0-2.86-3.8-2.88-5.52.25-.31 1.8-1.07 5.11-1.07 3.84 0 5 .84 5.1 1.01.1.17 0 .2 0 .33.16 1.25-.2 2.5-1.01 3.47zm13.13 1.78c-3.04 0-5.17-.61-6.31-1.78a4.49 4.49 0 01-1.03-3.47 1 1 0 000-.27c.1-.23 1.28-1.07 5.11-1.07 3.3 0 4.86.76 5.11 1.07 0 1.72-.31 5.52-2.87 5.52z",
      "fill": "#534741",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M38.13 37.72c.63-.3 1.31-.47 2.01-.5.56-.02 1.1.16 1.53.5 0 0-.79-1.84-1.77-1.84-.97 0-1.77 1.84-1.77 1.84z",
      "fill": "#D0BBAC",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e205e772","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/oldman/MentoringOldManIcon.vue
// module id = 09cafae8441c29002d60
// module chunks = 89